module.exports = __webpack_public_path__ + "img/voice.3f17c786.svg";